import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative bg-black/40 border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="brand text-3xl glow mb-4">Celestine</div>
            <p className="text-gray-400 text-sm">
              Boszorkány • Numerológus • Access Bars
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-yellow-200 font-semibold mb-4">Linkek</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-yellow-200 transition">Főoldal</Link></li>
              <li><Link to="/termekek" className="text-gray-400 hover:text-yellow-200 transition">Termékek</Link></li>
              <li><Link to="/kosar" className="text-gray-400 hover:text-yellow-200 transition">Kosár</Link></li>
              <li><Link to="/profil" className="text-gray-400 hover:text-yellow-200 transition">Profil</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-yellow-200 font-semibold mb-4">Jogi információk</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/impresszum" className="text-gray-400 hover:text-yellow-200 transition">Impresszum</Link></li>
              <li><Link to="/adatkezeles" className="text-gray-400 hover:text-yellow-200 transition">Adatkezelés</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-gray-400">
          © {new Date().getFullYear()} Celestine – Minden jog fenntartva.
        </div>
      </div>

      <style jsx>{`
        .brand {
          font-family: "Great Vibes", cursive;
        }
        .glow {
          text-shadow: 0 0 12px rgba(255, 255, 255, 0.35), 0 0 24px rgba(199, 146, 12, 0.25);
        }
      `}</style>
    </footer>
  );
};

export default Footer;